import { useEffect } from 'react'
import { NumericFormat } from 'react-number-format'
import { useSearchParams } from 'react-router-dom'
import { useLocalStorage } from '../../../../../remote/local-storage'
import { ComboSelectWithLabel } from '../../../../components/combo-select-with-label'
import { Button } from '../../../../components/ui/button'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '../../../../components/ui/form'
import { Input } from '../../../../components/ui/input'
import { Textarea } from '../../../../components/ui/textarea'
import { LoadConsultor } from '../../../member/sell/actions/load-consultor'
import { CreateService } from '../actions/services/create-service'
import { LoadServiceId } from '../actions/services/load-service-id'

type RegisterServiceProps = {
  id: string
}

export function RegisterService({ id }: RegisterServiceProps) {
  const [params] = useSearchParams()
  const { getUnitId } = useLocalStorage()
  const { form, onSubmit } = CreateService()
  const { data: consultants } = LoadConsultor([])
  const { load } = LoadServiceId()
  const isEditMode = Boolean(id)

  useEffect(() => {
    form.setValue('unidade.id', getUnitId())
  }, [params])

  const fetchProductId = async () => {
    if (isEditMode) {
      const data = await load(id)
      console.log(data)
      form.setValue('id', data.id)
      form.setValue('idUsuario', data.idUsuario)
      form.setValue('nome', data.nome)
      form.setValue('valor', data.valor)
      form.setValue('observacao', data.observacao)
    }
  }

  useEffect(() => {
    fetchProductId()
  }, [id])

  return (
    <div className="">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-2">
          <FormField
            control={form.control}
            name="idUsuario"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  <span className="text-gray-400">*</span>
                  Consultor
                </FormLabel>
                <FormControl>
                  <ComboSelectWithLabel defaultValue={field.value} data={consultants || []} onChange={(e) => field.onChange(e.value)} />
                </FormControl>
                <FormMessage className="text-xs">{form.formState.errors?.idUsuario?.message}</FormMessage>
              </FormItem>
            )}
          />
          <div className="grid grid-cols-2 gap-2">
            <FormField
              control={form.control}
              name="nome"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>
                    <span className="text-gray-400">*</span>
                    Nome
                  </FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                  <FormMessage className="text-xs">{form.formState.errors?.nome?.message}</FormMessage>
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="valor"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>
                    <span className="text-gray-400">*</span>
                    Valor
                  </FormLabel>
                  <FormControl>
                    <NumericFormat
                      className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                      thousandSeparator="."
                      decimalSeparator=","
                      prefix="R$ "
                      decimalScale={2}
                      getInputRef={field.ref}
                      {...field}
                      fixedDecimalScale={true}
                    />
                  </FormControl>
                  <FormMessage className="text-xs">{form.formState.errors?.valor?.message}</FormMessage>
                </FormItem>
              )}
            />
          </div>
          <FormField
            control={form.control}
            name="observacao"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  <span className="text-gray-400"></span>
                  Observação
                </FormLabel>
                <FormControl>
                  <Textarea {...field} value={field.value ?? ''}></Textarea>
                </FormControl>
                <FormMessage className="text-xs">{form.formState.errors?.observacao?.message}</FormMessage>
              </FormItem>
            )}
          />

          <Button type="submit" className="bg-acelerafit-green-400 text-muted hover:bg-cashfit-green-200">
            Enviar
          </Button>
        </form>
      </Form>
    </div>
  )
}
